import { Provider, Type } from '@angular/core';
import { ItemPricing, ProductDetails, StandardItemDetails, WireItemDetails } from '@idealsupply/products-api-angular-client';
import {
  ItemEntity,
  ItemPricingEntity,
  ProductDetailsEntity,
  provideItemConverter,
  provideItemPricingConverter,
  provideProductDetailsConverter,
} from 'products-data';
import { provideProductDetailsComponent } from '../layouts/product-detail/provideProductDetailsComponent';
import { provideProductResultComponent } from '../layouts/product-result/provideProductResultComponent';
import { provideItemResultComponent } from '../../item/layouts/item-result/provideItemResultComponent';

export interface ProductTypeConfig {
  productResultComponent?: Type<unknown>;
  productDetailComponent?: Type<unknown>;
  itemResultComponent?: Type<unknown>;
  productDetailsConverter?: (raw: ProductDetails) => ProductDetailsEntity;
  itemConverter?: (raw: StandardItemDetails | WireItemDetails) => ItemEntity;
  pricingConverter?: (raw: ItemPricing) => ItemPricingEntity;
}

export function provideProductType(type: string, config: ProductTypeConfig): Provider[] {
  const providers: Provider[] = [];
  if (config.productResultComponent) {
    providers.push(...provideProductResultComponent({ type, component: config.productResultComponent }));
  }
  if (config.productDetailComponent) {
    providers.push(...provideProductDetailsComponent({ type, component: config.productDetailComponent }));
  }
  if (config.itemResultComponent) {
    providers.push(...provideItemResultComponent({ type, component: config.itemResultComponent }));
  }
  if (config.productDetailsConverter) {
    providers.push(provideProductDetailsConverter(type, config.productDetailsConverter));
  }
  if (config.itemConverter) {
    providers.push(provideItemConverter(type, config.itemConverter));
  }
  if (config.pricingConverter) {
    providers.push(provideItemPricingConverter(type, config.pricingConverter));
  }
  return providers;
}
